import * as FlightsSortings from './FlightsSortings.css';
export default {
    FlightsSortings
};
